import { Expose } from "class-transformer";

export class UpdateAccountingAccountDto {
  @Expose()
  id: string;

  @Expose()
  description: string;

  @Expose()
  counterpartId?: string | null;
}
